function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import gsap from 'gsap';
import { throttle } from 'lodash';
import { Component, register } from 'ovee.js';

var _class = (_dec = register('collapsing-header'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.lastPosition = 0;
      this.currentPosition = 0;
      this.hoverHeader = false;
      this.detectDirection = throttle(this.detectDirection.bind(this), 100);
      this.html = document.documentElement;
      this.headerHeight = this.$element.clientHeight;
      this.lang = document.querySelector('.lang');
      this.initTimeline();
      this.bind();
      requestAnimationFrame(function () {
        _this.detectDirection(true);
      });
    }
  }, {
    key: "initTimeline",
    value: function initTimeline() {
      var _this2 = this;

      var tl = gsap.timeline({
        paused: true
      });
      var headerHeight = this.$element.getBoundingClientRect().height;
      this.$on('resize', window, function () {
        headerHeight = _this2.$element.getBoundingClientRect().height;
      });
      tl.fromTo(this.$element, {
        y: function y() {
          return 0;
        }
      }, {
        y: function y() {
          return headerHeight * -1;
        },
        duration: 0.25,
        ease: 'Quad.easeInOut'
      });
      this.tl = tl;
    }
  }, {
    key: "hide",
    value: function hide() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isHidden && !this.html.classList.contains('menu-visible')) {
        this.isHidden = true;

        if (immediate) {
          this.tl.seek(this.tl.duration());
        } else {
          this.tl.play();
        }

        if (this.lang) this.lang.classList.remove('is-active');
      }
    }
  }, {
    key: "show",
    value: function show() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isHidden) {
        this.isHidden = false;
        clearTimeout(this.hideTimeout);

        if (immediate) {
          this.tl.seek(0);
        } else {
          this.tl.reverse();
        }
      }
    }
  }, {
    key: "detectDirection",
    value: function detectDirection() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPosition = window.pageYOffset || document.documentElement.scrollTop;

      if (this.currentPosition >= this.lastPosition && this.currentPosition > this.headerHeight) {
        this.hide(immediate);
      } else {
        this.show(immediate);
      }

      this.lastPosition = this.currentPosition;
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this3 = this;

      this.$on('scroll load', window, function () {
        return _this3.detectDirection();
      });
    }
  }, {
    key: "isNotHover",
    get: function get() {
      return this.hoverHeader === false;
    }
  }, {
    key: "isMobile",
    get: function get() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };